import { z } from "zod";

export const getAccrualPreviewsRequestSchema = z.object({
  checkIDs: z.array(z.string()),
  companyID: z.string(),
});

export type TGetAccrualPreviewsRequestSchema = z.infer<
  typeof getAccrualPreviewsRequestSchema
>;

export const getAccrualPreviewsResponseSchema = z.record(
  z.string(),
  z.object({
    checkID: z.string(),
    accruals: z.array(z.any()),
    error: z.string().optional(),
  })
);

export type TGetAccrualPreviewsResponseSchema = z.infer<
  typeof getAccrualPreviewsResponseSchema
>;
